export const getStatusLabel = (status, t) => {
  switch (status) {
    case 'Completed':
      return t('projects.badge.completed');
    case 'In Construction':
      return t('projects.badge.inConstruction');
    case 'Act 14':
      return t('projects.badge.act14');
    case 'Act 15':
      return t('projects.badge.act15');
    default:
      return t('projects.badge.newRelease');
  }
};

export const getTypeLabel = (type, t) => {
  const typeKeyMap = {
    'Residential Complex': 'residentialComplex',
    'Luxury Residential': 'luxuryResidential',
    'Modern Residential': 'modernResidential',
    'Mixed-Use Development': 'mixedUseDevelopment',
    'Eco-Residential Complex': 'ecoResidentialComplex',
  };

  const key = typeKeyMap[type];
  if (key) {
    return t(`projects.types.${key}`);
  }
  return type;
};
